import styled from "styled-components";

import { LoadingSkeletonBaseStyles } from "shared/components/molecules/LoadingSkeleton/atoms/styles";

export const LoadingSkeletonCircleContainer = styled(LoadingSkeletonBaseStyles)`
  width: ${({ size }) => size || "40px"};
  height: ${({ size }) => size || "40px"};

  border-radius: 50%;
`;
